<template>
  <div class="calico-credit-box-item">
    <div class="credit-box-label">
      <span class="label--xsmall">{{ label }}</span>
      <CalicoTooltip
        v-if="tooltipBody"
        :header="tooltipHeader"
        :body="tooltipBody"
      />
    </div>
    <CalicoCreditBoxScale
      :value="value"
      :score="score"
    />
  </div>
</template>

<script>
import CalicoCreditBoxScale from '@/components/calico/creditBoxScale/index.vue';
import CalicoTooltip from '@/components/calico/tooltip/index.vue';

export default {
  name: 'CalicoCreditBoxItem',
  components: {
    CalicoCreditBoxScale,
    CalicoTooltip
  },
  props: {
    label: {
      type: String,
      required: true
    },
    score: {
      type: Number,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    tooltipHeader: {
      type: String,
      default: ''
    },
    tooltipBody: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.calico-credit-box-item {
  @include stack-space($space-xxsmall);
  gap: $space-small;

  .credit-box-label {
    @include inline-space($space-xxsmall);
    align-items: center;
    gap: $space-xsmall;

    .bi-question-circle {
      color: $color-lapis;
    }
  }
}
</style>
